import { Stack, Typography } from '@mui/material'
import { WorkflowStateAction } from '@/types/workflow-state-actions'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'
import PrimaryTextWrapper from './PrimaryTextWrapper'

type EntrataRemoveInvalidTableRowsDisplayProps = {
  action: WorkflowStateAction
}

export default function DeleteEmptyTableRowsDisplay({
  action,
}: EntrataRemoveInvalidTableRowsDisplayProps) {
  const { fieldsMap } = useProjectContext()
  const tableId = action.params.table_id
  const emptyFieldIds = action.params.empty_field_ids as string[]
  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        Removes any table rows from the{' '}
        <PrimaryTextWrapper>{fieldsMap[tableId]?.name}</PrimaryTextWrapper>{' '}
        table where{' '}
        {emptyFieldIds.length
          ? 'cells for the configured columns are empty.'
          : 'all cells in the row are empty.'}
      </Typography>
      {!!emptyFieldIds.length && (
        <div>
          <Typography variant="body2">
            <b>Columns:</b>
          </Typography>
          {emptyFieldIds.map((fieldId) => (
            <Typography key={fieldId} variant="body2" color="text.secondary">
              {fieldsMap[fieldId]?.name}
            </Typography>
          ))}
        </div>
      )}
    </Stack>
  )
}
